// WorkerSidebar.js (HIDDEN VERSION)

import React from "react";

const WorkerSidebar = () => {
  return null; // 🚫 render NOTHING
};

export default WorkerSidebar;
